import React from 'react';
import styles from './AskTheTeam.module.scss'
import TeamIcon from "./TeamIcon/TeamIcon";



function AskTheTeam({team = [], onClick = () => {}}) {
    return <div className={styles.AskTheTeam}>
    {team && team.map( member => {
            return <div key={member.name} className={styles.TeamMember} onClick={() => onClick(member)} >
                <div className={styles.ImageContainer} >
                    <div className={styles.Icon} >
                        <div className={styles.MemberIcons}>
                            <div className={styles.MemberIcon}>
                                <TeamIcon variant={member.icon} alt={member.iconAlt} />
                            </div>
                        {member.dialog !== '' &&
                            <div className={styles.MemberIcon}>
                                <TeamIcon variant={'bubble'} alt={'Dialog'} />
                            </div>
                        }
                        </div>
                    </div>

                </div>
                <div className={styles.Captions}>
                    <div className={styles.Avatar}>
                        <img  src={member.img} width={"97"} height={"97"} alt={member.alt} />
                    </div>
                    <div className={styles.Role}>{member.name}</div>
                    <div className={styles.Role}>{member.role}</div>
                </div>

            </div>
        })}
    </div>
}

export default AskTheTeam;
